import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.header`
  height: ${({ theme }) => theme.metrics.header_height};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ theme }) => theme.metrics.margin};
  margin-bottom: 0;
  gap: ${({ theme }) => theme.metrics.gap};
  padding: ${({ theme }) => theme.metrics.padding};
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  /* Layout para impressão */
  @media print {
    display: none;
  }
`;

export const Title = styled.h1`
  margin-left: ${({ theme }) => theme.metrics.margin};
  white-space: nowrap;
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const Pages = styled.div`
  height: 100%;
  display: flex;
  gap: 5px;
  overflow: hidden;
  overflow-x: auto;

  /* Esconder scrollbar */
  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const PageButton = styled.button<{ active?: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 14px;
  white-space: nowrap;
  background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
  color: ${({ theme }) => theme.colors.textBackground};
  transition: 0.2s;

  &:hover {
    background-color: ${({ theme }) => darken(0.2, theme.colors.background)};
  }

  ${({ theme, active }) =>
    active &&
    `
    color: ${theme.colors.textPrimary};
    background-color: ${darken(0.05, theme.colors.primary)};
    pointer-events: none;
  `}
`;
